import styled from 'styled-components';
import colors from 'utils/colors';

const Wrapper = styled.a`
    width: calc(100%);
    -webkit-font-smoothing: antialiased;
    -webkit-touch-callout: none;
    display: flex;
    flex-direction: column;
    padding-left: 15px;
    padding-right: 15px;
    padding-block: 13px;
    background: ${colors.black};
    border-radius: 8px;
    transition: 0.3s;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    position: relative;

    &:hover{
        background: #3C3F45;
    }
`;

export default Wrapper;